import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { useIsOwner, useSessionPermission } from '@btime/react-session'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useModalData } from '../../../../../components/modals/ModalsContext'
import { useNavigation } from '../../../../../utils/contexts/NavigationContext'
import { useOpenEditRoutineModal } from '../../../../../utils/routes/modals/modalsActions'
import { useRemoveRoutines } from '../../_requests/removeRoutine'

export const useRowsActions = item => {
  const { entities } = useModalData() || {}
  const isOwner = useIsOwner()
  const canCreate = useSessionPermission('createRoutine')
  const canEdit = useSessionPermission('editRoutine')
  const canDelete = useSessionPermission('deleteRoutine')
  const { t } = useTranslation('common')

  const navigate = useNavigation()

  const [deleteItems, { loading }] = useRemoveRoutines()
  const openEditModal = useOpenEditRoutineModal()

  const singleOptions = useMemo(
    () => [
      ...appendIf(isOwner, {
        value: t('logs'),
        icon: 'RiTimeLine',
        onClick: () => navigate(`/logs?entityTriggerIds=${item.id}`),
        to: `/logs?entityTriggerIds=${item?.id}`
      }),

      ...appendIf(canEdit && !item.readOnly, {
        value: t('edit'),
        icon: 'BsPencil',
        onClick: () => openEditModal({ id: item.id, entities })
      }),

      ...appendIf(canDelete, {
        value: t('remove'),
        color: COLORS.red,
        icon: 'BsTrash',
        onClick: () => deleteItems(item)
      })
    ],
    [item, canDelete, canEdit, deleteItems, navigate, t]
  )

  return [singleOptions, loading]
}
